import { ReactComponent as BusinessesIcon } from "assets/icons/shop.svg";
import { ReactComponent as RevenueIcon } from "assets/icons/sidebar/arrow-down.svg";
import { ReactComponent as RewardsIcon } from "assets/icons/sidebar/coin.svg";
import { ReactComponent as CreditIcon } from "assets/icons/sidebar/credit.svg";
import { ReactComponent as GridIcon } from "assets/icons/sidebar/grid.svg";
import { ReactComponent as AuditLogsIcon } from "assets/icons/sidebar/layer.svg";
import { ReactComponent as MarketingIcon } from "assets/icons/sidebar/megaphone.svg";
import { ReactComponent as SupportIcon } from "assets/icons/sidebar/message-question.svg";
import { ReactComponent as SavingsIcon } from "assets/icons/sidebar/money-bag.svg";
import { ReactComponent as OnDemandSalaryIcon } from "assets/icons/sidebar/moneys.svg";
import { ReactComponent as ReferralProgramIcon } from "assets/icons/sidebar/people.svg";
import { ReactComponent as TransactionsIcon } from "assets/icons/sidebar/reverse.svg";
import { ReactComponent as SettingsIcon } from "assets/icons/sidebar/setting.svg";
import { ReactComponent as ShieldIcon } from "assets/icons/sidebar/shield-tick.svg";
import { ReactComponent as IndividualsIcon } from "assets/icons/sidebar/user.svg";
import { TransactionsSubRouteName } from "features/business-transactions/content";
import { BusinessSavingsTypeEnum } from "features/businesses-savings/content/types";
import { BusinessesStatus } from "features/businesses/businesses/content";
import { IndividualSavingsTabStatus } from "features/individuals-savings/consts";
import { ROUTES } from "routes/constants";
import { replaceIdParamsInRouteWithValue } from "utils";

import { ISideBarRoute } from "./types";

const BUSINESSES_PAGE_ALL_TAB = replaceIdParamsInRouteWithValue({
  route: ROUTES.BUSINESSES_PAGE,
  idParamsName: ":activeStatus",
  value: BusinessesStatus.ALL,
});
export const MAX_LINK_TEXT_LENGTH = 16;
export const SIDE_BAR_ROUTES: ISideBarRoute[] = [
  {
    route: {
      path: ROUTES.DASHBOARD_PAGE,
      text: "Dashboard",
    },
    icon: <GridIcon />,
  },
  {
    route: {
      path: ROUTES.UI_COMPONENTS_DEMO_PAGE,
      text: "UI Components Demo",
    },
    icon: <ReferralProgramIcon />,
    subRoutes: [
      {
        path: ROUTES.LOGIN_PAGE,
        text: "Auth Layout",
      },
    ],
    hasSubRoutes: true,
  },
  {
    route: {
      path: ROUTES.COMPLIANCE_PAGE,
      text: "Compliance",
    },
    icon: <ShieldIcon />,
    subRoutes: [
      {
        path: ROUTES.BUSINESSES_COMPLIANCE_PAGE_READY_FOR_REVIEW,
        text: "Businesses",
      },
      {
        path: ROUTES.INDIVIDUALS_COMPLIANCE_PAGE_READY_FOR_REVIEW,
        text: "Individuals",
      },
    ],
    hasSubRoutes: true,
    isSubRoutesTitleNotARoute: true,
  },
  {
    route: {
      path: BUSINESSES_PAGE_ALL_TAB,
      text: "Businesses",
    },
    icon: <BusinessesIcon />,
  },
  {
    route: {
      path: ROUTES.INDIVIDUALS_PAGE,
      text: "Individuals",
    },
    icon: <IndividualsIcon />,
  },
  {
    route: {
      path: ROUTES.TRANSACTIONS_PAGE_ALL,
      text: "Transactions",
    },
    icon: <TransactionsIcon />,
    subRoutes: [
      {
        path: replaceIdParamsInRouteWithValue({
          route: ROUTES.TRANSACTIONS_PAGE_ALL,
          idParamsName: ":transactionType",
          value: TransactionsSubRouteName.TRANSFERS,
        }),
        text: "All",
        mainValuePresentInAllRoute: "/transactions/all",
      },
      {
        path: replaceIdParamsInRouteWithValue({
          route: ROUTES.BUSINESSES_TRANSACTIONS_PAGE,
          idParamsName: ":transactionType",
          value: TransactionsSubRouteName.TRANSFERS,
        }),
        text: "Businesses",
        mainValuePresentInAllRoute: "/transactions/businesses",
      },
      {
        path: replaceIdParamsInRouteWithValue({
          route: ROUTES.INDIVIDUALS_TRANSACTIONS_PAGE,
          idParamsName: ":transactionType",
          value: TransactionsSubRouteName.TRANSFERS,
        }),
        text: "Individuals",
        mainValuePresentInAllRoute: "/transactions/individuals",
      },
    ],
    hasSubRoutes: true,
    isSubRoutesTitleNotARoute: true,
  },
  {
    route: {
      path: ROUTES.CREDIT_PAGE,
      text: "Credit",
    },
    icon: <CreditIcon />,
  },
  {
    route: {
      path: ROUTES.REVENUE_PAGE,
      text: "Revenue",
    },
    icon: <RevenueIcon />,
  },
  {
    route: {
      path: ROUTES.SAVINGS_PAGE,
      text: "Savings",
    },
    icon: <SavingsIcon />,
    subRoutes: [
      {
        path: replaceIdParamsInRouteWithValue({
          route: ROUTES.BUSINESSES_SAVINGS_PAGE,
          idParamsName: ":savingsType",
          value: BusinessSavingsTypeEnum.VAULT,
        }),
        text: "Businesses",
        mainValuePresentInAllRoute: "/savings/businesses",
      },
      {
        path: replaceIdParamsInRouteWithValue({
          route: ROUTES.INDIVIDUALS_SAVINGS_PAGE,
          idParamsName: ":savingsType",
          value: IndividualSavingsTabStatus.FLEX,
        }),
        text: "Individuals",
        mainValuePresentInAllRoute: "/savings/individuals",
      },
    ],
    hasSubRoutes: true,
    isSubRoutesTitleNotARoute: true,
  },
  {
    route: {
      path: ROUTES.REWARDS_PAGE,
      text: "Rewards",
    },
    icon: <RewardsIcon />,
  },
  {
    route: {
      path: ROUTES.REFERRAL_PROGRAM_PAGE,
      text: "Referral Program",
    },
    icon: <ReferralProgramIcon />,
  },
  {
    route: {
      path: ROUTES.MARKETING_PAGE,
      text: "Marketing",
    },
    icon: <MarketingIcon />,
  },
  {
    route: {
      path: ROUTES.ON_DEMAND_SALARY_PAGE,
      text: "On-Demand Salary",
    },
    icon: <OnDemandSalaryIcon />,
  },
  {
    route: {
      path: ROUTES.SUPPORT_PAGE,
      text: "Support",
    },
    icon: <SupportIcon />,
  },
  {
    route: {
      path: ROUTES.SETTINGS_PAGE,
      text: "Settings",
    },
    icon: <SettingsIcon />,
  },
  {
    route: {
      path: ROUTES.AUDIT_LOGS_PAGE,
      text: "Audit Logs",
    },
    icon: <AuditLogsIcon />,
  },
];
